/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectDailyTaskReportCommand } from '../../models/delete-project-daily-task-report-command';
import { DeleteProjectDailyTaskReportCommandResult } from '../../models/delete-project-daily-task-report-command-result';

export interface ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Params {
      body?: DeleteProjectDailyTaskReportCommand
}

export function apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectDailyTaskReportCommandResult>;
    })
  );
}

apiProjectDailyTaskReportsDeleteProjectDailyTaskReportDelete$Plain.PATH = '/api/ProjectDailyTaskReports/DeleteProjectDailyTaskReport';
